import {AxiosRequest, HttpUtils} from "../../../utils/HttpUtils";
import {MailTemplateDto} from "../dto/MailTemplateDto";
import {MailTemplateSearchCondition} from "../dto/MailTemplateSearchCondition";

export const MailTemplateApi = {

    queryMailTemplates: async (body: MailTemplateSearchCondition) => {
        try {
            const requestUrl = '/v1/mail/template/query';
            const axiosResponse = await AxiosRequest.post(requestUrl, body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    getMailTemplateDetail: async (id: string) => {
        try {
            const params = new Map<string, string>();
            params.set('id', id);
            const requestUrl = HttpUtils.addQueryString('/v1/mail/template/detail', params);
            const axiosResponse = await AxiosRequest.get(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    createMailTemplate: async (body: MailTemplateDto) => {
        try {
            const requestUrl = '/v1/mail/template/create';
            const axiosResponse = await AxiosRequest.post(requestUrl, body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    updateMailTemplate: async (body: MailTemplateDto) => {
        try {
            const requestUrl = '/v1/mail/template/update';
            const axiosResponse = await AxiosRequest.post(requestUrl, body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    deleteMailTemplate: async (id: string) => {
        try {
            const params = new Map<string, string>();
            params.set('id', id);
            const requestUrl = HttpUtils.addQueryString('/v1/mail/template/delete', params);
            const axiosResponse = await AxiosRequest.post(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },
};
